import CashFlowIframeAbstract from './cashFlowIframeAbstract';

const defaultConfig = {
    formSelector: '#cashFlowFrameFormDialog',
    frameContainer: 'dialogForm_cashFlowFrame',
    cashFlowParamsToFormSelector: '.credit-card-form',
    iframeLocation: 'profile',
    cssRules: [
        'input{height:24px;padding:4px;float:right;width:330px;font-size:12px;font-weight:bold;border-width:1px;border-radius:4px;}',
        'label{display:inline-block;float:left;font-size:12px;font-weight:bold;font-family:Tahoma,Arial;width:120px;text-align:right;padding-right:20px;margin-top:11px;margin-left:32px;}',
        'select{width:161px;height:35px;padding:5px;margin-right:10px;border-radius:4px;background-color:white;margin-top:16px;margin-bottom:16px;}',
        '.error{color:red;}'
    ],
    frameOptions : {
        useexpiry : 'true',
        usecvv : 'true',
        cardlabel : 'Card Number:',
        expirylabel : 'Expiration:',
        cvvlabel : 'CVV:',
        orientation : 'custom',
        placeholdercvv: 'Code',
        placeholdermonth: 'Month',
        placeholderyear: 'Year',
        unique: false,
        formatinput : true,
        autofocus : true,
        invalidinputevent : true,
        enhancedresponse: true
    }
};

export default class CashFlowIframeDialog extends CashFlowIframeAbstract {
    constructor() {
        super(defaultConfig);
    }
}
